<template>
  <div class="read-tabs tabs">
    <div class="tabs-container">
      <Transition name="fade" mode="out-in">
        <div v-if="!isTagGroupLoaded" class="tabs-header-skeleton">
          <div class="skeleton-tabs">
            <div v-for="(item, index) in 5" :key="index" class="skeleton-shine tab">
              <!--  -->
            </div>
          </div>
        </div>
        <div v-if="isTagGroupLoaded" id="tabs-header" class="tabs-header">
          <div v-if="isScrollable" :class="{disabled: isLeftmost}" class="tab-nav-arrow left" @click="scrollToLeft">
            <span class="material-icons">
              chevron_left
            </span>
          </div>
          <div id="tab-nav-scroller" ref="tabNavScroller" :class="{isScrollable: isScrollable}" class="tab-nav-scroller" @scroll="tabOnScroll">
            <div v-for="(tagGroup, index) in tagGroupList" :key="index" :class="{current: index === currentTab}"
                 class="tab-nav" @click="tabOnClick(index, tagGroup)"
            >
              {{ tagGroup.displayName }}
            </div>
            <div v-if="!isScrollable" ref="tabNavUnderline" class="tab-underline">
              <!--  -->
            </div>
          </div>
          <div v-if="isScrollable" :class="{disabled: isRightmost}" class="tab-nav-arrow right" @click="scrollToRight">
            <span class="material-icons">
              chevron_right
            </span>
          </div>
        </div>
      </Transition>
      <Transition name="fade" mode="out-in">
        <div v-if="!isListLoaded" class="tabs-content-skeleton">
          <div class="skeleton-container">
            <div v-for="(item, index) in 5" :key="index" class="skeleton-item--article">
              <div class="skeleton-shine cover">
                <!--  -->
              </div>
              <div class="info">
                <div class="skeleton-shine subject" />
                <div class="skeleton-shine content" />
                <div class="skeleton-shine content" />
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="isListLoaded && currentArticleList && currentArticleList.length > 0 && isArticleLastPage[currentTagGroup.id]"
             class="tabs-content"
        >
          <ReadArticleList :article-list="currentArticleList" />
        </div>
        <div v-else-if="isListLoaded && currentArticleList && currentArticleList.length > 0"
             class="tabs-content"
        >
          <ReadArticleList :article-list="currentArticleList" />
          <LoadMoreBtn :btn-content="$t('ARTICLE.MORE')" :on-click="loadMoreArticle" />
          <br>
        </div>
        <div v-else-if="isListLoaded && currentArticleList && currentArticleList.length === 0"
             class="tabs-empty"
        >
          <CommonEmptyContent :locale-key="'COMMON.EMPTY_CONTENT_TEXT'" />
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import CommonEmptyContent from '@/components/common/DummyStatus/CommonEmptyContent'
import ArticleService from '@/assets/services/ArticleService'
import TagGroupService from '@/assets/services/TagGroupService'
import ReadArticleList from '@/components/read/ReadArticleList'
import LoadMoreBtn from '@/components/common/LoadMoreBtn'

const TAG_GROUP_NUM = 20
export default {
  name: 'ReadTabs',
  components: {
    ReadArticleList,
    CommonEmptyContent,
    LoadMoreBtn
  },
  directives: {},
  props: {},
  data() {
    return {
      isTagGroupLoaded: false,
      isListLoaded: false,
      minTabWidth: 129,
      currentTab: 0,
      currentTagGroup: {},
      scrollLeft: 0,
      isScrollable: false,
      tagGroupList: [],
      tagGroupArticleStore: {},
      tagGroupArticleCurrentPage: {},
      currentArticleList: [],
      isArticleLastPage: {},
      page: {
        perPage: 6,
        current: 1,
        total: 0
      }
    }
  },
  computed: {
    isLeftmost() {
      return this.scrollLeft < 10 // allow small offset
    },
    isRightmost() {
      return this.$refs.tabNavScroller.scrollWidth - (this.$refs.tabNavScroller.clientWidth + this.scrollLeft) < 10 // allow small offset
    },
    emptyMessage() {
      const listenProductName = 'MUZIK' + process.env.VUE_APP_MUZIK_LISTEN.toUpperCase()
      const localedMsg = this.$t('COMMON.EMPTY_CONTENT_TEXT', { listen: listenProductName })
      return localedMsg.replace(listenProductName, `<a class="keyword pointer" href="/">${listenProductName}</a>`)
    }
  },
  created() {
  },
  async mounted() {
    window.addEventListener('resize', this.tabOnResize)
    this.initTabList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.tabOnResize)
  },
  methods: {
    async initTabList() {
      const tabDefaultIndex = 0
      await this.getTagGroupList()
      if (this.tagGroupList && this.tagGroupList.length > 0) {
        this.currentTagGroup = this.tagGroupList[tabDefaultIndex] // set default
        await this.getArticleList()
        this.checkScrollable() // init
        this.updateTabUnderLine(tabDefaultIndex) // init
      } else {
        // handle tagGroupList empty
      }
    },
    tabOnResize() {
      this.$nextTick(() => {
        this.checkScrollable()
        this.updateTabUnderLine(this.currentTab)
        // this.tabOnClick(this.currentTab, this.currentTagGroup)
      })
    },
    updateTabUnderLine(index) {
      const tabNavWidthObj = this.calculateDynamicTabsWidth(index)
      if (!this.isScrollable && this.$refs.tabNavUnderline && this.$refs.tabNavScroller) {
        // calculate
        const underlineLeft = tabNavWidthObj.tabNavLeft
        const underlineRight = this.$refs.tabNavScroller.clientWidth - tabNavWidthObj.tabNavRight
        if (this.currentTab < index) {
          this.$refs.tabNavUnderline.classList.remove('move-right')
          this.$refs.tabNavUnderline.classList.add('move-left')
        } else if (this.currentTab > index) {
          this.$refs.tabNavUnderline.classList.add('move-right')
          this.$refs.tabNavUnderline.classList.remove('move-left')
        }
        this.$refs.tabNavUnderline.style.left = `${underlineLeft}px`
        this.$refs.tabNavUnderline.style.right = `${underlineRight}px`
      }
    },
    checkTabInFullVersion(index) {
      const tabNavWidthObj = this.calculateDynamicTabsWidth(index)
      const tabLeft = tabNavWidthObj.tabNavLeft
      const tabRight = tabNavWidthObj.tabNavRight
      const visionRight = this.$refs.tabNavScroller.clientWidth + this.$refs.tabNavScroller.scrollLeft
      if (this.$refs.tabNavScroller.scrollLeft > tabLeft) {
        const offset = this.$refs.tabNavScroller.scrollLeft - tabLeft
        // this.$refs.tabNavScroller.scrollLeft = tabLeft
        this.scrollTo('left', offset)
      } else if (visionRight < tabRight) {
        const offset = tabRight - visionRight
        // this.$refs.tabNavScroller.scrollLeft = this.$refs.tabNavScroller.scrollLeft + offset
        this.scrollTo('right', offset)
      }
    },
    tabOnClick(index, tagGroup) {
      if (index === this.currentTab) return
      // 1. add tab underline animation
      this.updateTabUnderLine(index)
      // 2. check tab full in vision
      this.checkTabInFullVersion(index)
      // 3.change tab
      this.currentTab = index
      this.currentTagGroup = tagGroup
      // 4. Update article list content
      this.getArticleList()
    },
    tabOnScroll() {
      this.scrollLeft = this.$refs.tabNavScroller ? this.$refs.tabNavScroller.scrollLeft : 0
    },
    scrollTo(direction = 'left', distance = this.minTabWidth, duration = 400, frequency = 20) {
      let times = duration / frequency
      let move = distance / times
      if (direction === 'right') {
        move = (move * -1)
      }
      let intervalId = setInterval(() => {
        this.$refs.tabNavScroller.scrollLeft -= move
        if (times <= 0) {
          clearInterval(intervalId)
        } else {
          times--
        }
      }, frequency)
    },
    scrollToLeft(e) {
      const tabNavWidth = this.minTabWidth
      this.scrollTo('left', tabNavWidth, 300, 20)
    },
    scrollToRight(e) {
      const tabNavWidth = this.minTabWidth
      this.scrollTo('right', tabNavWidth, 300, 20)
    },
    calculateDynamicTabsWidth(limitTabIndex = -1) {
      /**
       * @description calculate tabs total width, left anf right bound
       *
       * @returns {object}
       */
      if (!this.$refs.tabNavScroller) {
        return
      }
      let tabNavWidthTotal = 0
      let tabNavLeft = 0
      let tabNavRight = 0
      // if limitTabIndex === -1, calculate all child node
      limitTabIndex = limitTabIndex > -1 ? limitTabIndex : this.$refs.tabNavScroller.childNodes.length
      this.$refs.tabNavScroller.childNodes.forEach((node, index) => {
        if (node.clientWidth && node.className.indexOf('tab-nav') > -1 && index <= limitTabIndex) {
          if (index === 0) {
            tabNavLeft = 0 // first tab ,left is 0
          } else {
            tabNavLeft = tabNavWidthTotal // give calculated so far (all left tab width)
          }
          // and then, add new tab width
          tabNavRight += node.clientWidth
          tabNavWidthTotal += node.clientWidth
        }
      })
      return {
        tabNavLeft,
        tabNavRight,
        tabNavWidthTotal
      }
    },
    checkScrollable() {
      let scrollable = false
      if (this.$refs.tabNavScroller) {
        const tabNavScrollerWidth = this.$refs.tabNavScroller.clientWidth
        // method 1: if dynamic tab width
        const tabNavWidthObj = this.calculateDynamicTabsWidth(-1)
        // method 2: if fixed tab width
        // const tabNavScrollerNodeLength = this.$refs.tabNavScroller.childNodes.length - 2 // underline
        // const tabNavWidth = this.$refs.tabNavScroller.childNodes[0].clientWidth || this.minTabWidth
        // const tabNavWidthTotal = tabNavWidth * tabNavScrollerNodeLength

        // check
        if (tabNavScrollerWidth < tabNavWidthObj.tabNavWidthTotal) {
          scrollable = true
        }
      }
      this.isScrollable = scrollable
    },
    async getTagGroupList() {
      this.isTagGroupLoaded = false
      const params = {
        'per_page': TAG_GROUP_NUM,
        'page': 1
      }
      const tagGroupList = await TagGroupService.getTagGroups(params)
      if (tagGroupList) {
        this.tagGroupList = tagGroupList.data
        const currentLocale = this.$i18n.locale.toLowerCase()
        this.tagGroupList.forEach(tagGroupItem => {
          let matchedLocaleObj = tagGroupItem.name.find(item => item.locale === currentLocale)
          if (!matchedLocaleObj) {
            matchedLocaleObj = tagGroupItem.name.find(item => item.locale === 'en-us')
          }
          if (!matchedLocaleObj && tagGroupItem.name.length > 0) {
            matchedLocaleObj = tagGroupItem.name[0]
          }
          tagGroupItem.displayName = matchedLocaleObj.value || ''
        })
      } else {
        // Error handle tagGroupList
        //
      }
      this.isTagGroupLoaded = true
    },
    async getArticleList() {
      if (this.currentTagGroup.id && this.tagGroupArticleStore[this.currentTagGroup.id]) {
        this.currentArticleList = this.tagGroupArticleStore[this.currentTagGroup.id]
      } else if (this.currentTagGroup.id) {
        this.isListLoaded = false
        this.currentArticleList = []
        // query article list
        const params = {
          'per_page': this.page.perPage,
          'page': 1
        }
        const articleList = await ArticleService.getArticlesByTagGroupId(this.currentTagGroup.id, params)
        if (articleList) {
          this.currentArticleList = articleList.data
          this.tagGroupArticleStore[this.currentTagGroup.id] = articleList.data
          this.tagGroupArticleCurrentPage[this.currentTagGroup.id] = 1
          this.isArticleLastPage[this.currentTagGroup.id] = false

          if (articleList.current_page >= articleList.last_page) {
            this.isArticleLastPage[this.currentTagGroup.id] = true
          }
        }
      }
      // trigger transition, and change tab smoothly
      setTimeout(() => {
        this.isListLoaded = true
      }, 150)
    },
    async getArticleLists() {
      // query article list
      const params = {
        'per_page': this.page.perPage,
        'page': this.tagGroupArticleCurrentPage[this.currentTagGroup.id] + 1
      }
      const articleList = await ArticleService.getArticlesByTagGroupId(this.currentTagGroup.id, params)
      if (articleList) {
        this.isListLoaded = false

        // Method 1 : old articles replaced by new articles
        // this.currentArticleList = []
        // this.currentArticleList = articleList.data
        // this.tagGroupArticleStore[this.currentTagGroup.id] = articleList.data

        // Method 2 : new articles appended to old articles
        this.currentArticleList = this.currentArticleList.concat(articleList.data)
        this.tagGroupArticleStore[this.currentTagGroup.id] = this.tagGroupArticleStore[this.currentTagGroup.id].concat(articleList.data)

        this.tagGroupArticleCurrentPage[this.currentTagGroup.id] += 1
        this.isArticleLastPage[this.currentTagGroup.id] = false

        if (articleList.current_page >= articleList.last_page) {
          this.isArticleLastPage[this.currentTagGroup.id] = true
        }

        // trigger transition, and change tab smoothly
        setTimeout(() => {
          this.isListLoaded = true
        }, 150)
      }
    },
    loadMoreArticle() {
      this.getArticleLists()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

$tabNavHeight: 58px;
$tabNavWidth: 129px;
$tabUnderlineHeight: 3px;
$tabFontSize: 16px;
$tabIconSize: 24px;

.tabs {
  &-container {
    // margin: 24px 0;
  }
  &-header {
    display: block;
    height: $tabNavHeight + $tabUnderlineHeight;
    position: relative;
    // border: solid 1px salmon;
    margin-bottom: 36px;
    overflow: hidden; // hidding scroller's scroll bar
  }
  &-empty {
    display: block;
    padding: 120px 0;
    text-align: center;
  }
  &-content {
    display: block;
    // min-height: 735px;
    // border: solid 1px salmon;
  }
  .tab-nav {
    &-arrow {
      z-index: 11;
      height: $tabNavHeight;
      width: 36px;
      position: absolute;
      top: 0;
      padding-top: calc((#{$tabNavHeight} - #{$tabIconSize}) / 2);
      text-align: center;
      background-color: white;
      color: $grey-7d;
      cursor: pointer;
    }
    &-arrow:hover {
      color: $link-hover;
    }
    &-arrow.disabled {
      color: $grey-ec;
      cursor: not-allowed;
    }
    &-arrow.left {
      left: 0;
    }
    &-arrow.right {
      right: 0;
    }
    &-scroller {
      height: calc((#{$tabNavHeight} + #{$tabUnderlineHeight}) + 17px); // add scroller height for hidden
      width: calc(100%);
      white-space: nowrap; // single line
      // overflow: auto;
      overflow-x: scroll;
      overflow-y: hidden;
      // box-sizing: content-box;
    }
    &-scroller.isScrollable {
      width: calc(100% - 72px);
      margin: 0 36px;
    }
    &-scroller::-webkit-scrollbar {
      // Non-standard property
      display: none;
    }

    z-index: 10;
    display: inline-block;
    height: $tabNavHeight;
    // width: $tabNavWidth;
    min-width: $tabNavWidth;
    padding: 0 16px; // for dynamic tab width
    line-height: $tabNavHeight;
    font-size: $tabFontSize;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    text-decoration: none;
    color: $grey-9b;
    cursor: pointer;
  }
  .tab-nav.current {
    color: $grey-50;
  }
  .tab-underline {
    position: absolute;
    left: auto;
    right: auto;
    height: $tabUnderlineHeight;
    color: $theme-red;
    background: $theme-red;
  }
  .tab-underline.move-left {
    transition: left 0.5s cubic-bezier(0.35, 0, 0.25, 1), right 0.225s cubic-bezier(0.35, 0, 0.25, 1);
  }
  .tab-underline.move-right {
    transition: right 0.5s cubic-bezier(0.35, 0, 0.25, 1), left 0.225s cubic-bezier(0.35, 0, 0.25, 1);
  }
}

@media only screen and (min-width: 1440px) {
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .tabs {
    .tab-nav.current {
      color: $grey-50;
      // border-bottom: none;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .tabs {
    &-container {
      margin: 0;
    }
    &-empty {
      padding: 60px 0;
      img {
        width: 270px;
      }
    }
    &-header {
      margin-bottom: 20px;
    }
    .tab-nav.current {
      color: $grey-50;
      // border-bottom: none;
    }
  }
}
</style>
